// i18n area 'tasks' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.fi-FI.meta.json.
import type { enUS } from './tasks'

export const fiFI: typeof enUS = {
  macrotasks: {
    title: 'Macrotaskit',
    subtitle: 'Koostettuja operaatioita — jatkettavissa epäonnistuneesta askeleesta tai keskeytettävissä',
    colType: 'Tyyppi',
    colTarget: 'Kohde',
    colPhase: 'Vaihe',
    colSteps: 'Askeleet',
    empty: 'Ei macrotaskeja',
    detail: 'Tiedot',
    failedAt: 'epäonnistui kohdassa',
    resume: 'Yritä uudelleen epäonnistuneesta askeleesta',
    abort: 'Keskeytä kaikki',
    cancel: 'Peruuta',
    actionError: 'Toiminto hylättiin'
  },
  tasks: {
    title: 'Taskit',
    searchPlaceholder: 'Hae tyypillä tai targetilla',
    type: 'Tyyppi',
    target: 'Target',
    phaseLabel: 'Vaihe',
    progress: 'Edistyminen',
    started: 'Aloitettu',
    finished: 'Päättynyt',
    node: 'Solmu',
    empty: 'Ei taskeja',
    loadError: 'Taskeja ei voitu ladata — onko TVirt-backend tavoitettavissa?',
    limboHint: "Solmu '{node}' ei ole ollut tavoitettavissa {time} lähtien — task pitää targetinsa write leasen, kunnes solmu palaa tai se attestoidaan sammuneeksi",
    nodeAttested: 'Solmu attestoitu sammuneeksi',
    phase: {
      queued: 'Jonossa',
      running: 'Käynnissä',
      succeeded: 'Valmis',
      failed: 'Epäonnistunut',
      cancelled: 'Peruutettu',
      'failed-at-step': 'Epäonnistui askeleessa',
      aborted: 'Keskeytetty'
    },
    dropdown: {
      tooltip: 'Käynnissä olevat taskit',
      title: 'Käynnissä olevat taskit',
      empty: 'Ei käynnissä olevia taskeja',
      viewAll: 'Näytä kaikki taskit'
    },
    detail: {
      open: 'Tiedot',
      scope: 'Scope',
      message: 'Viesti',
      params: 'Parametrit',
      result: 'Tulos',
      errorTitle: 'Virhe',
      steps: 'Askeleet',
      failedAt: 'epäonnistui kohdassa',
      superseded: 'korvattu',
      step: 'Askel',
      parent: 'Emotask',
      failedStep: 'Epäonnistunut askel',
      log: 'Loki',
      logEmpty: 'Ei vielä lokirivejä',
      close: 'Sulje'
    },
    actions: {
      cancel: 'Peruuta',
      resume: 'Yritä uudelleen epäonnistuneesta askeleesta',
      abort: 'Keskeytä kaikki (kumoaa valmiit askeleet)',
      refused: 'Toiminto hylättiin'
    }
  },
  events: {
    loadError: 'Päiväkirjaa ei voitu ladata — onko TVirt-taustapalvelu tavoitettavissa?',
    title: 'Tapahtumat',
    subtitle: 'Klusterin historiallinen muisti: tapahtuneet tosiasiat, uusimmasta alkaen',
    filterSeverity: 'Vakavuus',
    filterCategory: 'Luokka',
    filterAll: 'Kaikki',
    searchLabel: 'Hae',
    searchPlaceholder: 'Hae koko päiväkirjasta',
    subjectFilter: 'Kohteen {subject} tapahtumat — näytä kaikki',
    colAt: 'Milloin',
    colSeverity: 'Vakavuus',
    colType: 'Tyyppi',
    colSubject: 'Kohde',
    colActor: 'Kuka',
    colNode: 'Node',
    colMessage: 'Viesti',
    empty: 'Ei tapahtumia',
    loadMore: 'Lataa lisää',
    actorSystem: 'järjestelmä',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Tapahtuman ID',
    taskCollectedHint: 'Taskilla on lyhyempi säilytysaika: kerätyn taskin linkki ei enää vastaa',
    severity: {
      info: 'Tieto',
      warning: 'Varoitus',
      error: 'Virhe',
      critical: 'Kriittinen'
    },
    category: {
      lifecycle: 'Elinkaari',
      config: 'Asetukset',
      availability: 'Saatavuus',
      security: 'Tietoturva'
    },
    type: {
      haNetsvcFailedOver: 'Verkkopalvelun failover',
      haNetsvcNoCandidate: 'Verkkopalvelu ilman ehdokassolmua',
      haNetsvcReaped: 'Paikallinen instanssi niitetty paluun yhteydessä',
      netsvcFloatipMoved: 'Kelluva IP siirtyi toiselle haltijalle',
      netsvcFloatipNoHolder: 'Kelluva IP ilman tervettä kohdetta',
      haAppFailedOver: 'App-instanssin failover',
      haAppNoCandidate: 'App-instanssi ilman ehdokassolmua',
      haAppStorageLocalSkip: 'App-instanssia ei siirretty: pysyvät tiedot ovat kuolleen solmun paikallisia',
      haAppReaped: 'App-instanssin paikallinen pod niitetty paluussa'
    }
  },
  audit: {
    loadError: 'Auditointirekisteriä ei voitu ladata — onko TVirt-taustapalvelu tavoitettavissa?',
    title: 'Auditointi',
    subtitle: 'Kuka teki mitä, milloin ja mihin kohteeseen — yritetyt teot, hylkäykset mukaan lukien',
    filterOutcome: 'Lopputulos',
    filterAll: 'Kaikki',
    filterSudo: 'Vain korotetut teot',
    colAt: 'Milloin',
    colActor: 'Kuka',
    colAction: 'Toiminto',
    colTarget: 'Kohde',
    colOutcome: 'Lopputulos',
    colNode: 'Node',
    empty: 'Ei kirjattuja tekoja',
    loadMore: 'Lataa lisää',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Reitti',
    detailProblem: 'Syy',
    detailTask: 'Task',
    detailClientIp: 'Mistä',
    detailId: 'Tietueen ID',
    detailSession: 'Istunto',
    taskHint: 'Hyväksytyn teon lopputulos elää tapahtumapäiväkirjassa, saman task-tunnuksen alla',
    outcome: {
      succeeded: 'Onnistui',
      accepted: 'Otettu vastaan',
      denied: 'Estetty',
      rejected: 'Hylätty',
      failed: 'Epäonnistui'
    }
  },
  notifications: {
    loadError: 'Ilmoituksia ei voitu ladata — onko TVirt-taustapalvelu tavoitettavissa?',
    actionError: 'Toiminto hylättiin',
    title: 'Ilmoitukset',
    subtitle: 'Kohteet, joihin päiväkirjan tosiasiat lähtevät klusterista',
    rulesTitle: 'Säännöt',
    rulesSubtitle: 'Mitkä tosiasiat lähtevät ja minne',
    deliveriesTitle: 'Toimitukset',
    deliveriesSubtitle: 'Jokaisen ilmoituksen tulos, ja syy kun se epäonnistuu',
    colName: 'Nimi',
    colKind: 'Tyyppi',
    colWhere: 'Minne',
    colScope: 'Scope',
    colSeverity: 'Vakavuus',
    colMatch: 'Suodatin',
    colTargets: 'Kohde',
    colAt: 'Milloin',
    colState: 'Tila',
    colEvent: 'Tapahtuma',
    colAttempts: 'Yritykset',
    colOutcome: 'Tulos',
    empty: 'Ei rivejä',
    matchAll: 'kaikki tosiasiat',
    test: 'Testaa',
    testOk: 'Testi-ilmoitus toimitettu kohteeseen {target}',
    testFailed: 'Testi kohteeseen {target} epäonnistui: {reason}',
    retry: 'Palauta jonoon',
    retried: 'Toimitus palautettu jonoon',
    grouped: 'ja {count} muuta toistoa',
    state: {
      failed: 'Epäonnistui',
      pending: 'Jonossa',
      sending: 'Lähetetään',
      sent: 'Lähetetty'
    },
    tabTargets: 'Kohteet',
    tabRules: 'Säännöt',
    tabDeliveries: 'Toimitukset',
    targetCreateTitle: 'Uusi kohde',
    ruleCreateTitle: 'Uusi sääntö',
    nameHint: 'Pienet kirjaimet, numerot ja väliviivat; yksilöllinen per näkyvyysalue',
    kindImmutableHint: 'Muuttumaton: tyypin vaihtaminen tarkoittaa uuden kohteen luomista',
    kindSmtp: 'Sähköposti (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Tila',
    enabledOn: 'Aktiivinen',
    enabledOff: 'Keskeytetty',
    smtpHost: 'SMTP-palvelin',
    smtpPort: 'Portti',
    smtpPortHint: 'Tavallisesti: 25 ilman TLS:ää, 587 starttls:llä, 465 tls:llä',
    smtpSecurity: 'Suojaus',
    smtpFrom: 'Lähettäjä',
    smtpTo: 'Vastaanottajat',
    smtpToHint: 'Yksi tai useampi pilkulla erotettu osoite',
    webhookUrl: 'URL',
    payload: 'Sisältö',
    payloadHint: 'Minimal-tilassa tapahtuman viesti ja tiedot eivät poistu klusterista',
    credential: 'Tunnus',
    credentialNone: 'Ei mitään',
    credentialHintSmtp: 'Välityspalvelimen tunnus avainsäiliöstä; ei mitään tarkoittaa anonyymiä SMTP:tä',
    credentialHintWebhook: 'Allekirjoitussalaisuus avainsäiliöstä; ilman allekirjoitusta kuka tahansa URL:n tietävä voi esiintyä klusterina',
    minSeverityHint: 'Kynnys, ei joukko: tästä vakavuudesta ylöspäin',
    categories: 'Luokat',
    categoriesHint: 'Tyhjä = kaikki',
    types: 'Tapahtumatyypit',
    typesHint: 'Pilkulla erotettuna; tyhjä = kaikki. Tuntematon tyyppi hylätään',
    targetsHint: 'Vähintään yksi; niiden on oltava säännön näkyvyysalueella tai sen esivanhemmassa',
    recursiveOn: 'Myös lapsialueet',
    recursiveOff: 'Vain tämä alue',
    recursiveHint: 'Resurssit elävät lehdissä: ilman lapsia juuressa oleva sääntö ilmoittaa lähes mitään',
    repeatWindow: 'Ryhmittelyikkuna (s)',
    repeatWindowHint: 'Ikkunan sisällä toistot eivät lähetä postia: ne lasketaan ensimmäiseen. 0 poistaa käytöstä',
    targetInUseError: 'Kohde {name} on vielä säännön käytössä'
  }
}
